import { render, staticRenderFns } from "./UserWelcomeMailComposer.vue?vue&type=template&id=2423a79e&"
import script from "./UserWelcomeMailComposer.vue?vue&type=script&lang=js&"
export * from "./UserWelcomeMailComposer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports